import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../../common/Loading";
import { generateProjectColumns } from "./columns";
import ProjectProgressReviewNoteList from "./ProjectProgressReviewNoteList";

const ProjectProgressReviewList = ({
  data,
  loading,
  sorted,
  page,
  pageSize,
  pages,
  onPageSizeChange,
  onPageChange,
  onSortedChange,
  onRowClick = () => {},
  isMobile,
  onClickAdd,
  onClickEdit,
  onClickDelete,
  onProgressUpdate = () => {}
}) => {
  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }
  const PROJECT_COLUMNS = generateProjectColumns({ onProgressUpdate });
  const PROJECT_DATA = data.map((proj) => ({
    ...proj,
    progress:
      Array.isArray(proj.percent_complete) && proj.percent_complete.length
        ? proj.percent_complete[proj.percent_complete.length - 1].value
        : 0
  }));
  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        className="-highlight"
        columns={PROJECT_COLUMNS}
        data={PROJECT_DATA}
        manual
        sorted={sorted}
        pages={pages}
        page={page}
        pageSize={Math.min(data.length, pageSize)}
        showPagination={pages > 1}
        onSortedChange={onSortedChange}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        getTdProps={(state, rowInfo, column) => ({
          onClick: () => {
            if (
              column.id !== "favorites" &&
              column.id !== "percent_complete" &&
              !column.expander
            ) {
              onRowClick(rowInfo);
            }
          }
        })}
        expanded={data.map(() => true)}
        SubComponent={(row) => (
          <div
            style={{
              maxHeight: "300px",
              overflow: "scroll",
              marginBottom: "10px",
              marginLeft: "40px",
              marginRight: "40px"
            }}
          >
            <ProjectProgressReviewNoteList
              project={row.original}
              isMobile={isMobile}
              onClickAdd={onClickAdd}
              onClickEdit={onClickEdit}
              onClickDelete={onClickDelete}
            />
          </div>
        )}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
ProjectProgressReviewList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  sorted: PropTypes.array,
  onSortedChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onRowClick: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  isMobile: PropTypes.bool,
  onClickAdd: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func,
  onProgressUpdate: PropTypes.func
};

export default ProjectProgressReviewList;
